import { Component, Input, OnChanges} from '@angular/core';
import { FieldTypeSwitchComponent } from "../../../shared/components/field-type-switch/field-type-switch.component";
import { AfTranslatePipe } from '@shared/modules/translate/pipe/af-translate.pipe';

@Component({
  selector: 'customize-fields-switch-form',
  templateUrl: './customize-fields-switch-form.component.html',
  standalone: true,
  imports: [FieldTypeSwitchComponent, AfTranslatePipe]
})
export class CustomizeFieldsSwitchFormComponent implements OnChanges {
  customizeFieldsSwitchForm: any = {}

  constructor() { }

  @Input() field: any = null;
  @Input() isPrivate: any = null;
  @Input() hiddenInLandings: boolean = false;
  @Input() concept: any = {};
  @Input() typeView: string = 'normal';
  @Input() small: boolean = false;
  @Input() previewMode: boolean = false;

  ngOnChanges(): void {
    this.customizeFieldsSwitchForm.disabledFormConfiguration = this.previewMode || this.concept?.disabled;
  }

  changeOptionOn(e:any, type:string){
    switch(type){
      case 'private':
        this.field.private = e.newValue;
        this.changePrivate();
        break;
      case 'required':
        this.field[type] = e.newValue;
        if(!this.field.required && this.field.isManagerClassificator){
          this.field.isManagerClassificator = false;
        }
        break;
      case 'isDisaggregated':
        this.field[type] = e.newValue;
        if(!this.field.required && this.field.isDisaggregated){
          this.field.required = true;
        }
        break;
      default:
        this.field[type] = e.newValue;
        break;
    }
  }

  changePrivate(){
    if(this.field.private){
      this.field.isIdentifier = false;
    }
  }
}

